import { render } from "./ViewFilePanel.vue?vue&type=template&id=0d1a417c&lang=pug"
import script from "./ViewFilePanel.vue?vue&type=script&lang=js"
export * from "./ViewFilePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__